"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaDicionar = exports.yupDicionar = void 0;
const yup = __importStar(require("yup"));
const enums_1 = require("../enums");
exports.yupDicionar = yup.object({
    dbfname: yup.string().default('').max(8).required().label('Nome do DBF'),
    fname: yup.string().default('').max(10).required().label('Nome do campo'),
    ftype: yup
        .mixed()
        .oneOf(Object.values(enums_1.EDicionarName))
        .default(enums_1.EDicionarName.Texto)
        .required()
        .label('Tipo de campo'),
    flen: yup.number().default(1).required().min(1).integer().label('Tamanho do campo'),
    fdec: yup.number().default(0).required().min(0).integer().label('Casas decimais'),
    fdesc: yup.string().default('').max(125).required().label('Descrição do campo'),
    fpicture: yup.string().default(null).max(130).notRequired().nullable(),
    fmax: yup.number().default(0).required().min(0).integer(),
    fmin: yup.number().default(0).required().min(0).integer(),
    frequired: yup.boolean().required().default(false).label('Campo obrigatório'),
    fsectosee: yup.number().default(0).required().min(0).integer(),
    fsectoedit: yup.number().default(0).required().min(0).integer(),
    flookup: yup.string().default('').max(4).notRequired().nullable(),
    fdocumento: yup.boolean().required().default(false).label('Documento exigido pela escola'),
    fnentrega: yup.boolean().required().default(false).label('Não entrega pelo online'),
    fRequeridoMatricula: yup
        .boolean()
        .notRequired()
        .nullable()
        .default(false)
        .label('Requerido para matrícula ou rematrícula'),
    fRequerValidacao: yup.boolean().notRequired().nullable().default(false).label('Requer validação de entrega'),
});
exports.schemaDicionar = exports.yupDicionar.shape({});
